
export function NumberToLocaleString(value: number|undefined|null, options?: {locale?: string,minimumFractionDigits?: number, maximumFractionDigits?: number} ): string|undefined
{  
  if (undefined === value || null === value)
    return;
  
  if (Number.isNaN(value))
    return; 
   
  const baseprecision = { minimumFractionDigits: options?.minimumFractionDigits, maximumFractionDigits: options?.maximumFractionDigits ?? 6 };
  return value.toLocaleString(options?.locale ?? "en-US",baseprecision);
}
export function prettyCurrency(value: number|undefined|null, options?: {locale?: string, currency?: string, negativeCurrencyDisplay?: boolean } | null): string|undefined
{  
  if (undefined === value || null === value)
    return;
  
  if (Number.isNaN(value))
    return; 

  if (options?.negativeCurrencyDisplay && value < 0) {
    return "(" + value.toLocaleString(options?.locale ?? "en-US",{style:"currency", currency: options?.currency ?? "USD",signDisplay: "never"}) + ")";
  }  
  return value.toLocaleString(options?.locale ?? "en-US",{style:"currency", currency: options?.currency ?? "USD"});
} 

export function prettyCurrencyNegative(value: number|undefined|null): string|undefined
{  
  return prettyCurrency(value, {negativeCurrencyDisplay: true});
}

export function getCurrencyClass(value: number|undefined|null): string {
  if ((value ?? 0) < 0)  return 'text-danger';
  return "";
}